<template>
  <div class="myApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" @resize="handleResize">
    <div style="height:20px"></div>
    <div class="use">
      <img class="avatar" :src="userData.avatar" />
      <div class="right">
        <h2>{{userData.username}} </h2>
        <p>
          <span>普通会员</span>
          <font @click="attend">立即认证<em class="el-icon-arrow-right"></em></font>
        </p>
      </div>
      <div style="clear:both"></div>
      <ul>
        <li>
          <h3>0.00</h3>
          <div>物业缴费</div>
        </li>
        <li @click="$router.push('mcoupon')">
          <h3>{{rs.coupon}}</h3>
          <div>优惠劵</div>
        </li>
        <li @click="$router.push('mwallet')">
          <h3>{{rs.wallet}}</h3>
          <div>去提现</div>
        </li>
        <li @click="$router.push('distribution')">
          <h3>{{rs.rose}}</h3>
          <div>我的分销</div>
        </li>
      </ul>
    </div>
    <div class="orderAll">
      <ul>
        <li @click="$router.push('porder')">
          <img src="~assets/demo/A9.jpg"/>
          <span>商圈订单</span>
        </li>
        <li @click="$router.push('msorder')">
          <img src="~assets/demo/A11.png"/>
          <span>电影订单</span>
        </li>
        <li @click="$router.push('lockYes')">
          <img src="~assets/demo/A10.png"/>
          <span>共享空间订单</span>
        </li>
      </ul>
    </div>

    <div class="meOrder">
      <div class="item-list" @click="$router.push('recharge')">
        <i class="el-icon-document left"></i>
        去充值
        <i class="el-icon-arrow-right right"></i>
      </div>
      <div class="item-list" @click="$router.push('none')">
        <i class="el-icon-bicycle left"></i>
        停车记录
        <i class="el-icon-arrow-right right"></i>
      </div>
      <div class="item-list" @click="$router.push('indy')">
        <i class="el-icon-user left"></i>
        个人信息
        <i class="el-icon-arrow-right right"></i>
      </div>
      <a class="item-list" href="tel:18177968850">
        <i class="el-icon-headset left"></i>
        联系客服
        <i class="el-icon-arrow-right right"></i>
      </a>
      <div class="item-list" @click="$router.push('follow')">
        <i class="el-icon-folder-add left"></i>
        关注有礼
        <i class="el-icon-arrow-right right"></i>
      </div>
    </div>

    <div :style="bool == 1 ? 'height:85px' :'height:65px'"></div>
    <div class="footers footCurt" :style="bool == 1 ? 'padding-bottom:22px' : 'padding-bottom:0px'">
      <div class="footer-item" @click="$router.push('demo')">
        <img src="~assets/demo/A7.png"/>
        <div>首页</div>
      </div>
      <div class="footer-item" @click="$router.push('parking')">
        <img src="~assets/demo/A6.png"/>
        <div>停车缴费</div>
      </div>
      <div class="footer-item on">
        <img src="~assets/demo/A8.png"/>
        <div>我的</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        rs:'',
        total:0,
        code:'',
        s_id:0,
        phone:'',
        isIphone:false,
        bool:0
      };
    },
    beforeMount() {
      window.removeEventListener("resize", this.handleResize);
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/my');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      window.addEventListener("resize", this.handleResize);
      this.attestUser()
    },

    methods: {
      jump:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.bool = (h >= 800 && this.isPhone() ? 1 : 0);
      },
      handleResize:function(e){
        if(this.curHeight < e.currentTarget.innerHeight && this.isPhone()){
          this.bool = 1;
        }else {
          if(this.curHeight >= 800 && this.curHeight == e.currentTarget.innerHeight && this.isPhone()){
            this.bool = 1;
          }else{
            this.bool = 0;
          }
        }
      },
      isPhone:function(){
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
      },
      order:function(){
        window.location.href="http://user.4008005216.com/main/scenicOrder?id=1"
      },
      attend:function(){
        window.location.href="http://user.4008005216.com/main/attest"
      },

      attestUser:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/user/mine',
          params:{
            //user_id:888
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.rs = res.phone;
          that.fullscreenLoading = false;
        }).catch(err=>{
          that.fullscreenLoading = false
        });
      },
      copy:function(){
        var Url2=document.querySelector("#copy");
        Url2.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$alert('复制成功！', '提示', {
          confirmButtonText: '确定'
        });
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%
  }
  .myApp{
    max-width:640px;
    background:#222630;
    margin:0 auto;
    position:relative;
  }
  .myApp .use{
    width:92%;
    height: 192px;
    margin:0 auto 30px auto;
    border-radius: 4px;
    box-shadow: 0px 4px 40px 0px rgba(123, 123, 123, 0.1);
    background: linear-gradient(223.09deg, rgb(185, 165, 144) -18.103%,rgb(121, 96, 72) 100%);
  }
  .myApp .use img{
    width:74px;
    height:74px;
    border-radius:100%;
    float:left;
    margin:20px
  }
  .myApp .use .right{
    height:80px;
    float:left;
    width:calc(100% - 114px);
    margin-top:17px
  }
  .myApp .use .right h2{
    color:#fff;
    font-size:26px;
    font-weight: 400;
    margin:8px 0 8px 0
  }
  .myApp .use .right p{
    height: 24px;
  }
  .myApp .use .right p span{
    float:left;
    border-radius: 2px;
    background: linear-gradient(-45.00deg, rgb(221, 201, 178) 0%,rgb(184, 152, 122) 100%);
    color:#fff;
    width: 80px;
    height: 24px;
    font-size:14px;
    text-align:center;
    line-height: 24px;
  }
  .myApp .use .right p font{
    float:right;
    color:#fff;
    font-size:14px;
    line-height: 24px;
    margin-right:12px
  }
  .myApp .use ul{
    clear:both;
    padding:10px 0 0px 0;
    width:100%
  }
  .myApp .use ul li{
    float:left;
    width:25%;
    position:relative;
  }
  .myApp .use ul li:after{
    position:absolute;
    content:'';
    width:1px;
    height:30px;
    background: rgb(220, 201, 182);
    right:0;
    top:50%;
    transform: translateY(-50%);
  }
  .myApp .use ul li:last-child:after{
    background:none;
  }
  .myApp .use ul li h3{
    text-align:center;
    font-size:20px;
    color:rgb(220, 201, 182)
  }
  .myApp .use ul li div{
    text-align:center;
    font-size:14px;
    color:rgb(52, 48, 44);
    padding-top:3px;
  }

  .myApp .orderAll{
    border-radius: 4px;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
    background: rgb(43, 48, 61);
    width:92%;
    margin:0 auto 30px auto;
  }

  .myApp .orderAll ul{
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    padding: 15px 0;
  }
  .myApp .orderAll ul li{
    width:33%;
  }
  .myApp .orderAll ul li img{
    display: block;
    width: 40px;
    height: 40px;
    margin: 0 auto;
  }
  .myApp .orderAll ul li span{
    display: block;
    text-align: center;
    color: rgb(153, 153, 153);
    font-size: 15px;
    padding-top: 2px;
  }

  .myApp .meOrder{
    border-radius: 4px;
    background: rgb(27, 30, 38);
    width:92%;
    margin:0 auto;
  }
  .myApp .meOrder .item-list{
    width:100%;
    font-size:17px;
    height:70px;
    line-height:70px;
    border-bottom:solid 1px rgba(151, 151, 151,0.18);
    display:block;
    color: rgb(255, 229, 200);
    font-weight:500;
    text-decoration: none;
  }


  .myApp .meOrder .left{
    float:left;
    font-size:22px;
    height:70px;
    line-height:70px;
    margin:0 8px 0 4%
  }
  .myApp .meOrder .right{
    float:right;
    font-size:15px;
    height:70px;
    line-height:70px;
    margin-right:3%
  }

  .myApp .footCurt{
    box-shadow: 0px -4px 30px 0px rgba(0, 0, 0, 0.5);
    background: linear-gradient(180.00deg, rgb(53, 58, 69),rgb(34, 38, 48) 100%);
  }
  .myApp .footCurt .footer-item{
    font-size:14px;
    color:#96969F
  }
  .myApp .footCurt .on{
    color: rgb(220, 199, 175);
  }
</style>